<eau-alert-page
    [title]="'error_page.title.page_not_found' | translate"
    [text]="'error_page.text.page_not_found' | translate"
    iconType="info"
></eau-alert-page>
